<mat-card class="tarjeta-contrato">

  <div class="cabecera">
    <div class="titulo">
      <mat-icon>description</mat-icon>
      <div>
        <span class="etiqueta-titulo">Contrato</span>
        <span class="numero">{{ contratoDetailDto?.numeroContrato }}</span>
      </div>
    </div>

    <span class="chip-estado" [ngClass]="claseEstado()">
      {{ contratoDetailDto?.estadoContrato?.descripcion | titlecase }}
    </span>
  </div>

  <div class="grilla-datos">

    <div class="dato">
      <mat-icon>home_work</mat-icon>
      <div class="contenido">
        <span class="etiqueta">Propiedad</span>
        <span class="valor">{{ ubicacionPropiedad() | titlecase }}</span>
      </div>
    </div>

    <div class="dato">
      <mat-icon>person</mat-icon>
      <div class="contenido">
        <span class="etiqueta">Inquilino</span>
        <span class="valor">{{ contratoDetailDto?.inquilino?.persona?.descripcion | titlecase }}</span>
      </div>
    </div>

    <!-- Un contrato puede tener varios propietarios: van como chips, no como
         texto separado por guiones, que dejaba un guión colgando al final. -->
    <div class="dato">
      <mat-icon>groups</mat-icon>
      <div class="contenido">
        <span class="etiqueta">
          {{ (contratoDetailDto?.propietarios?.length || 0) > 1 ? 'Propietarios' : 'Propietario' }}
        </span>
        <div class="chips">
          <span class="chip-propietario" *ngFor="let p of contratoDetailDto?.propietarios; trackBy: trackByItems">
            {{ p?.persona?.descripcion | titlecase }}
          </span>
          <span class="valor sin-dato" *ngIf="!contratoDetailDto?.propietarios?.length">Sin propietarios</span>
        </div>
      </div>
    </div>

    <div class="dato">
      <mat-icon>event</mat-icon>
      <div class="contenido">
        <span class="etiqueta">Duración</span>
        <span class="valor">
          {{ contratoDetailDto?.fechaComienzo | date:'dd/MM/yyyy' }}
          <span class="separador">al</span>
          {{ contratoDetailDto?.fechaVencimiento | date:'dd/MM/yyyy' }}
        </span>

        <!-- Barra de avance: cuánto del contrato transcurrió -->
        <div class="progreso" *ngIf="porcentajeTranscurrido() !== null">
          <div class="barra">
            <div class="relleno" [class.vencido]="porcentajeTranscurrido()! >= 100"
              [style.width.%]="porcentajeTranscurrido()"></div>
          </div>
          <span class="texto-progreso">
            {{ porcentajeTranscurrido() }}% transcurrido
            <ng-container *ngIf="diasRestantes() !== null && diasRestantes()! > 0">
              &middot; faltan {{ diasRestantes() }} días
            </ng-container>
            <ng-container *ngIf="diasRestantes() !== null && diasRestantes()! <= 0">
              &middot; vencido
            </ng-container>
          </span>
        </div>
      </div>
    </div>

    <div class="dato">
      <mat-icon>assignment</mat-icon>
      <div class="contenido">
        <span class="etiqueta">Tipo de contrato</span>
        <span class="valor">{{ contratoDetailDto?.tipoContrato?.descripcion | titlecase }}</span>
      </div>
    </div>

  </div>
</mat-card>

<!-- Auditoría al final, como en el resto de las vistas de sólo lectura -->
<app-info-auditoria *ngIf="contratoDetailDto && contratoDetailDto.id > 0"
  entidad="Contratos" [id]="contratoDetailDto.id">
</app-info-auditoria>
